import styles from './Skeleton.module.css';

export type SkeletonProps = {
  /** 'cards' = grade de retângulos (telas de cadastro); 'linhas' = lista empilhada (movimentações). */
  tipo?: 'cards' | 'linhas';
  quantidade?: number;
  altura?: number;
};

/**
 * Placeholder pulsante exibido enquanto a primeira busca de dados está no ar —
 * nunca mostrar EmptyState antes de saber que a lista está realmente vazia.
 */
export default function Skeleton({ tipo = 'cards', quantidade = 6, altura }: SkeletonProps) {
  const itens = Array.from({ length: quantidade });
  const alturaFinal = altura ?? (tipo === 'cards' ? 148 : 56);

  return (
    <div className={tipo === 'cards' ? styles.grade : styles.lista} aria-hidden="true">
      {itens.map((_, indice) => (
        <div key={indice} className={styles.bloco} style={{ height: alturaFinal }} />
      ))}
    </div>
  );
}
